var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow-right") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5,13 L16.865,13 L13.232,17.36 C12.878,17.784 12.936,18.415 13.36,18.768 C13.785,19.122 14.415,19.064 14.769,18.64 L19.769,12.64 C19.808,12.593 19.827,12.538 19.856,12.486 C19.88,12.444 19.909,12.408 19.927,12.362 C19.972,12.247 19.999,12.126 19.999,12.004 C19.999,12.003 20,12.001 20,12 C20,11.999 19.999,11.997 19.999,11.996 C19.999,11.874 19.972,11.753 19.927,11.638 C19.909,11.592 19.88,11.556 19.856,11.514 C19.827,11.462 19.808,11.407 19.769,11.36 L14.769,5.36 C14.57,5.123 14.286,5 14,5 C13.774,5 13.547,5.076 13.36,5.232 C12.936,5.585 12.878,6.216 13.232,6.64 L16.865,11 L5,11 C4.448,11 4,11.448 4,12 C4,12.552 4.448,13 5,13",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-right",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\uD83C\\uDFA8-Icon-\\u0421olor",
    fill: "#0068F5",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBlue);
export default __webpack_public_path__ + "static/media/arrow-right-blue.e570687359f7241066e33db7e9862b41.svg";
export { ForwardRef as ReactComponent };